module.exports = __webpack_public_path__ + "img/header-diamondJewelry025Carat.d8d4652.webp";